const index = "department";

export const departmentEndpoint = Object.freeze({
  department: index,
  myDepartments: `${index}/my-departments`,
});
